'use client'

import { createContext, useContext, useMemo } from 'react'

import type { CommonProps } from '../../types/CommonProps'
import type { FullProduct } from '../../types/FullProduct'

export interface ProductContextType {
	product: FullProduct
}

type ProductProviderProps = Pick<CommonProps, 'product'> & {
	children: React.ReactNode
}

export const ProductContext = createContext<ProductContextType | undefined>(
	undefined
)

export function ProductProvider({
	product,
	children,
}: ProductProviderProps): React.ReactNode {
	const value = useMemo(
		() => ({
			product,
		}),
		[product]
	)

	return (
		<ProductContext.Provider value={value}>{children}</ProductContext.Provider>
	)
}

/** @throws {Error} If useProduct is used without ProductProvider */
export const useProduct = (): ProductContextType => {
	const context = useContext(ProductContext)
	if (!context) {
		throw new Error('useProduct must be used within a ProductProvider')
	}
	return context
}
